const about1 = "https://shpeuf.s3.amazonaws.com/public/about/about-1.jpg";
const about2 = "https://shpeuf.s3.amazonaws.com/public/about/about-2.jpg";
const about3 = "https://shpeuf.s3.amazonaws.com/public/about/about-3.jpg";
const about = "https://shpeuf.s3.amazonaws.com/public/about/about.jpg";

export {about1, about2, about3, about}